import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import ExpenseCategoryListLayer from "../components/ExpenseCategoryListLayer";
import CategoryModal from "../components/CategoryModal";

const ExpenseCategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalData, setModalData] = useState(null); // null=create, object=edit

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/expense-category`);
      const data = await res.json();
      setCategories(data);
    } catch (err) {
      console.log("Error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Expense Categories" />

      {loading ? (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      ) : (
    <ExpenseCategoryListLayer
  data={categories}
  onAdd={() => setModalData({})}
  onEdit={(row) => setModalData(row)}
  onRefresh={fetchCategories}
/>
      )}

      {/* Modal */}
    <CategoryModal
  show={modalData !== null}
  onClose={() => setModalData(null)}
  onAdd={() => setModalData(null)}   // Add mode
onEdit={(row) => setModalData(row)} // Edit mode

  data={modalData}
  onSaved={fetchCategories}
/>

    </MasterLayout>
  );
};

export default ExpenseCategoryPage;
